// CONFIGURAZIONE RAPIDA
const gameConfig = [
  { prize: "Buono 5%", cells: 4, time: 10, offset: 8 },
  { prize: "Penna", cells: 9, time: 10, offset: 6 },
  { prize: "Buono 10%", cells: 16, time: 10, offset: 5 },
  { prize: "Buono 20%", cells: 25, time: 10, offset: 4 },
  { prize: "LUCE ALTERNA", cells: 36, time: 10, offset: 3 },
];

const lotNames = [
  "LOTTO CL20-1947", "LOTTO CL21-1847", "LOTTO CL22-1747", "LOTTO CL23-1647", "LOTTO CL24-1547"
];

const levels = gameConfig;

// INIZIALIZZAZIONE DATI (Corretta per forzare sempre il render della classifica)
setTimeout(() => {
  loadConfig();
  renderStats();
}, 0);

const holeCenter = { x: 84, y: 55 };
const levelMessages = [
  "OTTIMO OCCHIO!<br>ORA LA SFIDA AUMENTA.",
  "I DIFETTI DIVENTANO PIÙ PICCOLI.<br>RESTA CONCENTRATO.",
  "SEI VICINO AL PREMIO FINALE.<br>NON COMMETTERE ERRORI.",
  "ULTIMO CONTROLLO QUALITÀ.<br>DAI IL MASSIMO!"
];

const home = document.querySelector("#home");
const startButton = document.querySelector("#start");
const levelInfo = document.querySelector("#levelInfo");
const timerBar = document.querySelector("#timerBar");
const message = document.querySelector("#message");
const game = document.querySelector("#game");
const adminMenu = document.querySelector("#adminMenu");
const adminArea = document.querySelector("#adminArea");
const statTotal = document.querySelector("#statTotal");

const statPrizeLabels = Array.from({length: 5}, (_, i) => document.querySelector(`#statPrize${i+1}Label`));
const statPrizes = Array.from({length: 5}, (_, i) => document.querySelector(`#statPrize${i+1}`));

const statsKey = "controlloQualitaPrizeStats";
const configKey = "controlloQualitaConfig";

let level = 0, timerFrame = null, levelStart = 0, levelDuration = 0;
let badIndex = -1, gameActive = false;
let audioUnlocked = false;

// PRE-CARICAMENTO AUDIO
const sounds = {
  success: new Audio(window.gameSounds.success),
  levelup: new Audio(window.gameSounds.levelup),
  fail: new Audio(window.gameSounds.fail),
  jackpot: new Audio(window.gameSounds.jackpot),
  scanner: new Audio(window.gameSounds.scanner),
  timeout: new Audio(window.gameSounds.timeout)
};

// AVVIO GIOCO
startButton.addEventListener("click", () => {
  if (!audioUnlocked) {
    Object.values(sounds).forEach(audio => {
        audio.muted = true; 
        let playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.then(() => {
                audio.pause();
                audio.currentTime = 0;
                audio.muted = false;
            }).catch(() => {});
        }
    });
    audioUnlocked = true;
  }

  home.hidden = true;
  playSound('scanner');
  [1000, 2000, 3000].forEach(delay => setTimeout(() => playSound('scanner'), delay));

  game.innerHTML = `
    <section class="prize-screen">
      <p class="prize-title">SCANSIONE LOTTO</p>
      <h2 class="prize-bomb">.....</h2>
      <p id="scanText" class="prize-label">VERIFICA TOLLERANZE...</p>
    </section>
  `;

  setTimeout(() => document.getElementById("scanText").textContent = "CONTROLLO FORATURA...", 1000);
  setTimeout(() => document.getElementById("scanText").textContent = "ANALISI DIMENSIONALE...", 2000);
  setTimeout(() => document.getElementById("scanText").textContent = "LOTTO IDENTIFICATO", 3000);

  setTimeout(() => {
    document.body.classList.add("playing");
    level = 0;
    loadLevel();
  }, 4000);
});

// AUDIO MANAGER
function playSound(name) {
  if (!sounds[name]) return;
  sounds[name].currentTime = 0;
  sounds[name].play().catch(err => console.log("Audio bloccato da iOS:", err));
}

// PIASTRINA SVG
function plate(dx, dy) {

  const bad = (dx !== 0 || dy !== 0);

  // fiocco leggermente fuori asse
  const bowX = bad
      ? 90 + (Math.random() < 0.5 ? -4 : 4)
      : 90;

  return `
<svg viewBox="0 0 180 180">

  <!-- ombra -->
  <rect
      x="28"
      y="44"
      width="124"
      height="112"
      rx="8"
      class="gift-shadow"/>

  <!-- pacco -->
  <rect
      x="25"
      y="40"
      width="124"
      height="112"
      rx="8"
      class="gift-body"/>

  <!-- riflesso -->
  <rect
      x="33"
      y="47"
      width="8"
      height="95"
      rx="4"
      class="gift-light"/>

  <!-- nastro verticale -->
  <rect
      x="81"
      y="40"
      width="12"
      height="112"
      class="gift-ribbon"/>

  <!-- nastro orizzontale -->
  <rect
      x="25"
      y="88"
      width="124"
      height="12"
      class="gift-ribbon"/>

  <!-- fiocco -->

  <path
      d="
      M ${bowX} 35
      C ${bowX-22} 12 ${bowX-34} 44 ${bowX-12} 49
      C ${bowX-2} 46 ${bowX-2} 39 ${bowX} 35
      "
      class="gift-bow"/>

  <path
      d="
      M ${bowX} 35
      C ${bowX+22} 12 ${bowX+34} 44 ${bowX+12} 49
      C ${bowX+2} 46 ${bowX+2} 39 ${bowX} 35
      "
      class="gift-bow"/>

  <ellipse
      cx="${bowX}"
      cy="36"
      rx="7"
      ry="6"
      class="gift-knot"/>

</svg>`;
}

// LOGICA LIVELLI
function loadLevel() {
  levelInfo.hidden = false;
  document.querySelector(".timerWrap").hidden = false;
  cancelAnimationFrame(timerFrame);
  gameActive = true;
  
  document.body.classList.remove("danger-overlay");
  document.documentElement.style.setProperty("--danger-width", "0px");
  message.textContent = "";

  const cfg = levels[level];
  const side = Math.sqrt(cfg.cells);
  const grid = document.createElement("div");
  const dirs = [[1, 0], [-1, 0], [0, 1], [0, -1]];const bowOffset =
    Math.random() < 0.5
        ? -cfg.offset
        : cfg.offset;

  levelInfo.textContent = `${lotNames[level]} • Premio: ${cfg.prize}`;
  game.innerHTML = "";
  grid.className = "grid";
  grid.style.gridTemplateColumns = `repeat(${side}, 1fr)`;
  badIndex = Math.floor(Math.random() * cfg.cells);

  for (let i = 0; i < cfg.cells; i++) {
    const cell = document.createElement("button");
    cell.className = "cell";
    cell.innerHTML = i === badIndex ? plate(d[0] * cfg.offset, d[1] * cfg.offset) : plate(0, 0);
    cell.addEventListener("click", () => selectCell(i, cell));
    grid.appendChild(cell);
  }

  game.appendChild(grid);
  startTimer(cfg.time);
}

function selectCell(index, cell) {
  if (!gameActive) return;

  if (index === badIndex) {
    gameActive = false;
    cancelAnimationFrame(timerFrame);
    
    document.body.classList.remove("danger-overlay");
    document.documentElement.style.setProperty("--danger-width","0px");

    cell.classList.add("good");
    playSound('success');

    setTimeout(() => {
      level++;
      level >= levels.length ? win() : showLevelPrize(levels[level - 1].prize);
    }, 1500);
    return;
  }
  
  fail('wrong');
}

// GESTIONE TEMPO E SCONFITTA/VITTORIA
function startTimer(totalTime) {
  levelStart = performance.now();
  levelDuration = totalTime * 1000;
  updateTimer();
}

function updateTimer() {
  if (!gameActive) return;
  const elapsed = performance.now() - levelStart;
  const progress = Math.max(0, 1 - elapsed / levelDuration);
  timerBar.style.width = `${progress * 100}%`;

  const secondsLeft = Math.ceil((levelDuration - elapsed) / 1000);
  let dangerWidth = 0;

  if (secondsLeft <= 4 && progress > 0) {
      const elapsedInDanger = 4 - (levelDuration - elapsed) / 1000;
      dangerWidth = Math.min(30, elapsedInDanger * 7.5);
      document.body.classList.add("danger-overlay");
  } else if (secondsLeft > 4) {
      document.body.classList.remove("danger-overlay");
  }

  document.documentElement.style.setProperty("--danger-width", `${dangerWidth}vw`);

  if (progress <= 0) {
      fail('timeout');
      return;
  }

  timerFrame = requestAnimationFrame(updateTimer);
}

function fail(reason) {
  gameActive = false;
  cancelAnimationFrame(timerFrame);
  
  if (reason === 'timeout') {
      playSound('timeout');
  } else {
      playSound('fail');
  }
  
  document.body.classList.add("danger-overlay");
  document.documentElement.style.setProperty("--danger-width", "30vw");
  
  const cells = document.querySelectorAll(".cell");
  if (cells[badIndex]) cells[badIndex].classList.add("flash");

  setTimeout(() => {
    document.body.classList.remove("danger-overlay");
    document.documentElement.style.setProperty("--danger-width", "0px");

    const prize = level === 0 ? "Nessun premio" : levels[level - 1].prize;
    if (level > 0) recordPrize(prize);
    showPrize(prize);
  }, 3000);
}

function showLevelPrize(prize) {
  playSound('levelup');
  document.body.classList.remove("playing");
  levelInfo.hidden = true;
  document.querySelector(".timerWrap").hidden = true;
  
  game.innerHTML = `<section class="level-prize-screen">
      <p class="level-prize-title">✓ CONTROLLO SUPERATO</p><br>
      <p class="prize-label">PREMIO SBLOCCATO</p>
      <h2>${prize.toUpperCase()}</h2>
      <p class="level-msg">${levelMessages[level - 1]}</p>
    </section>`;

  setTimeout(() => { document.body.classList.add("playing"); loadLevel(); }, 4000);
}

function showPrize(prize) {
  if (prize !== "Nessun premio") playSound('jackpot');
  document.body.classList.remove("playing");
  levelInfo.hidden = true;
  document.querySelector(".timerWrap").hidden = true;

  game.innerHTML = `
    <section class="prize-screen">
      <p class="prize-title">⚠ LOTTO RESPINTO</p><br>
      <p class="prize-label">Il controllo qualità non è stato superato.${prize !== "Nessun premio" ? '<br><br><strong>MA IL TUO PREMIO È AL SICURO!</strong>' : ''}</p>
      <h2 class="prize-bomb">${prize.toUpperCase()}</h2>
    </section>`;
  setTimeout(() => location.reload(), 5000);
}

function win() {
  playSound('jackpot');
  cancelAnimationFrame(timerFrame);
  document.body.classList.remove("danger-overlay");
  document.documentElement.style.setProperty("--danger-width","0px");

  const finalPrize = levels[levels.length - 1].prize;
  recordPrize(finalPrize);
  document.body.classList.remove("playing");
  levelInfo.hidden = true;
  document.querySelector(".timerWrap").hidden = true;

  game.innerHTML = `
    <section class="prize-screen">
      <p class="prize-title">🏆 CONTROLLO COMPLETATO</p><br>
      <p class="prize-label">Tutti i lotti hanno superato il controllo qualità.<br><br><strong>PREMIO FINALE SBLOCCATO</strong></p>
      <h2 class="prize-bomb">${finalPrize.toUpperCase()}</h2>
    </section>`;
  setTimeout(() => location.reload(), 7000);
}

// STATISTICHE & CONFIGURAZIONE
function getStats() {
  const fallback = { total: 0, prizes: levels.map(cfg => ({ name: cfg.prize, count: 0 })) };
  try {
    const saved = JSON.parse(localStorage.getItem(statsKey));
    if (!saved || !Array.isArray(saved.prizes)) return fallback;
    return {
      total: Number(saved.total) || 0,
      prizes: levels.map((cfg, index) => ({ name: cfg.prize, count: Number(saved.prizes[index]?.count) || 0 }))
    };
  } catch { return window.memoryStats || fallback; }
}

function saveStats(stats) {
  try { localStorage.setItem(statsKey, JSON.stringify(stats)); } catch { window.memoryStats = stats; }
}

function saveConfig() {
  localStorage.setItem(configKey, JSON.stringify({ prizes: levels.map(l => l.prize), offsets: levels.map(l => l.offset) }));
}

function loadConfig() {
  try {
    const saved = JSON.parse(localStorage.getItem(configKey));
    if (!saved) return;
    saved.prizes?.forEach((p, i) => { if (levels[i]) levels[i].prize = p; });
    saved.offsets?.forEach((o, i) => { if (levels[i]) levels[i].offset = Number(o); });
  } catch (err) {}
}

function recordPrize(prizeName) {
  const stats = getStats();
  const prize = stats.prizes.find(item => item.name === prizeName);
  if (!prize) return;
  stats.total++; prize.count++;
  saveStats(stats);
}

function renderStats() {
  const stats = getStats();
  statTotal.textContent = stats.total;
  statPrizes.forEach((el, i) => {
    const p = stats.prizes[i] || { name: "-", count: 0 };
    statPrizeLabels[i].textContent = `${p.name.toUpperCase()}:`;
    el.textContent = p.count;
    el.parentElement.hidden = !stats.prizes[i];
  });
}

// MENU SEGRETO ADMIN
let resetTimer;
const title = document.querySelector("#secretReset");

const startResetTimer = () => { clearTimeout(resetTimer); resetTimer = setTimeout(openAdminMenu, 5000); };
const stopResetTimer = () => clearTimeout(resetTimer);

title.addEventListener("touchstart", startResetTimer);
title.addEventListener("touchend", stopResetTimer);
title.addEventListener("touchcancel", stopResetTimer);
title.addEventListener("mousedown", startResetTimer);
title.addEventListener("mouseup", stopResetTimer);
title.addEventListener("mouseleave", stopResetTimer);

function openAdminMenu() {
  renderAdminHome();
  adminMenu.hidden = false;
}

function renderAdminHome() {
  adminArea.innerHTML = `
    <button id="btnPremiMenu">🏆 Premi</button>
    <button id="btnDifficoltaMenu">🎯 Difficoltà</button>
    <button id="btnResetMenu">📊 Azzera statistiche</button>
    <button id="btnCloseMenu">❌ Chiudi</button>
  `;
  document.getElementById("btnPremiMenu").onclick = showPrizesMenu;
  document.getElementById("btnDifficoltaMenu").onclick = showDifficultyMenu;
  document.getElementById("btnCloseMenu").onclick = () => adminMenu.hidden = true;
  document.getElementById("btnResetMenu").onclick = () => {
    if (confirm("AZZERARE LE STATISTICHE? Tutte le vincite verranno cancellate.")) {
      localStorage.removeItem(statsKey); location.reload();
    }
  };
}

function showPrizesMenu() {
  adminArea.innerHTML = levels.map((l, i) => `<button class="prizeEdit" data-index="${i}">${l.prize}</button>`).join('') + `<button id="backMenu">⬅️ Indietro</button>`;
  
  document.querySelectorAll(".prizeEdit").forEach(btn => {
    btn.onclick = () => {
      const idx = Number(btn.dataset.index);
      const newPrize = prompt("Nuovo nome premio:", levels[idx].prize);
      if (newPrize) { levels[idx].prize = newPrize; saveConfig(); renderStats(); showPrizesMenu(); }
    };
  });
  document.getElementById("backMenu").onclick = renderAdminHome;
}

function showDifficultyMenu() {
  adminArea.innerHTML = levels.map((l, i) => `<button class="editOffset" data-index="${i}">LOTTO ${i+1} • OFFSET ${l.offset}</button>`).join('') + `<button id="backMenu">⬅️ Indietro</button>`;
  
  document.querySelectorAll(".editOffset").forEach(btn => {
    btn.onclick = () => {
      const idx = Number(btn.dataset.index);
      const newOffset = prompt("Nuovo offset:", levels[idx].offset);
      if (newOffset !== null) { levels[idx].offset = Number(newOffset); saveConfig(); showDifficultyMenu(); }
    };
  });
  document.getElementById("backMenu").onclick = renderAdminHome;
}